import { generateUtilityClass, generateUtilityClasses } from '../../styles/classes';
export var sidebarLinkComponentName = 'QuantumSidebarLink';
export function getSidebarLinkUtilityClass(slot) {
    return generateUtilityClass(sidebarLinkComponentName, slot);
}
export var sidebarLinkClasses = generateUtilityClasses(sidebarLinkComponentName, [
    'root',
    'icon',
    'startIcon',
    'endIcon',
    'link',
    'title',
    'availabilityLabel',
    'decoration',
]);
